import React, { Component } from "react";
import Logo from "../../images/logo.png";
import { Link } from "react-router-dom";
import MobileMenu from "../../components/MobileMenu";

export default class Header2 extends Component {
  state = {
    isSearchShow: false,
  };

  searchHandler = () => {
    this.setState({
      isSearchShow: !this.state.isSearchShow,
    });
  };

  render() {
    const ClickHandler = () => {
      window.scrollTo(10, 0);
    };
    return (
      <header id="header">
        <div className="wpo-site-header">
          <nav className="navigation navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                  <div className="mobail-menu">
                    <MobileMenu />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="navbar-header">
                    <Link
                      onClick={ClickHandler}
                      className="navbar-brand"
                      to="/"
                    >
                      <img src={Logo} alt="logo" />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-6 col-md-1 col-1">
                  <div
                    id="navbar"
                    className="collapse navbar-collapse navigation-holder"
                  >
                    <button className="menu-close">
                      <i className="ti-close"></i>
                    </button>
                    <ul className="nav navbar-nav mb-2 mb-lg-0 menuItens">
                      <li className="menu-item-has-children">
                        <Link
                          className="fs-3"
                          onClick={ClickHandler}
                          to="/"
                        >
                          Home
                        </Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link
                          className="fs-3"
                          onClick={ClickHandler}
                          to="/recursos-humanos"
                        >
                          Recursos Humanos
                        </Link>
                      </li>

                      <li>
                        <Link
                          className="fs-3"
                          onClick={ClickHandler}
                          to="/desenvolvimento-de-carreira"
                        >
                          Desenvolvimento de Carreira
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-2 col-2">
                  <div className="header-right">
                    <div className="close-form">
                      <a
                        href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                        target="_blank"
                        rel="noreferrer"
                        className="btn theme-btn"
                      >
                        Fale conosco
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
    );
  }
}
